<div class="wrapper">
  <div class="flex-container">
    <div class="message">
      <p>We’re sorry. An error occurred whilst you tried to load this page.</p>
      <p>Please refresh your page and try again or contact us for support.</p>
      <p>The Land App Team</p>
    </div>
  </div>
</div>
